import React, { useEffect, useState } from 'react'

import image from '../../../../assets/images/banners/banner.png'
import imageMobile from '../../../../assets/images/banners/banner-mobile.png'
// import { BannerItem } from '../NewBanner.types'
import { handleCarouselClick } from '../NewBannerHelpers'
import style from './BannerType2.module.scss'

export interface BannerType2Data {
  leftText: string
  bottomText: string
  href: string
  textLink: string
}

export interface BannerType2Props {
  place: string | undefined
  id: string | undefined
  pageType: string
  bannerData: BannerType2Data
  customClass?: string[]
}

function BannerType2({
  place,
  id,
  pageType,
  bannerData,
  customClass,
}: BannerType2Props) {
  const [description, setDescription] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setDescription(prev => !prev)
    }, 8000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <a
      href={bannerData.href}
      target='_blank'
      onClick={() => {
        handleCarouselClick(`${bannerData.leftText}`, id, pageType, place)
      }}
      className={[style.NewBanner].join(' ')}
    >
      <div
        className={`${style.banner} ${
          customClass
            ? customClass.map((className: string) => style[className]).join(' ')
            : ''
        }`}
      >
        <div
          className={style.bannerTop}
          style={{ opacity: description ? 0 : 1 }}
        >
          <div className={style.banner__left}>
            <div className={style.banner__image}>
              <picture>
                <source media='(max-width: 1024px)' srcSet={imageMobile} />
                <img src={image} alt='Изображение баннера' />
              </picture>
            </div>
            <div
              className={style.banner__title}
              dangerouslySetInnerHTML={{ __html: bannerData.leftText }}
            />
          </div>
        </div>
        <div
          className={style.bannerDesk}
          style={{ opacity: description ? 1 : 0 }}
        >
          <div
            className={style.banner__textLink}
            dangerouslySetInnerHTML={{ __html: bannerData.textLink }}
          />
          <div
            className={style.banner__disclaimer}
            dangerouslySetInnerHTML={{ __html: bannerData.bottomText }}
          />
        </div>
      </div>
    </a>
  )
}

export default BannerType2
